export const formatText = (str: string) => {
    const arr = str.split('_');
    const result = [];
    for (const word of arr) {
      result.push(word.charAt(0).toUpperCase() +
                  word.slice(1).toLowerCase() // 👈️ lowercase remainder
      );
    }
    return result.join(' ');
};
